import React, {useState, useEffect} from 'react'
import {  Grid, MenuItem , FormHelperText, Autocomplete, Button, Typography, InputAdornment} from "@mui/material" ;
import { profileSettingStyles } from '../../../../styles/materialComponent';
import { CssTextField } from '../../../../styles/materialComponent';
import {useSelector, useDispatch} from "react-redux"
import { NotificationManager } from 'react-notifications';
import {fetchClients} from "../../../../actions/client"
import {getclientProperty} from "../../../../actions/property"
import { useNavigate, useLocation } from 'react-router-dom';

const ReportDetail = (props) => {
  const location = useLocation()
  const { formik, setReportValue } = props
    const classes = profileSettingStyles()

    useEffect(()=>{
    },[formik.values.client])

  return (
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          className={classes.textField1}
          required
          variant="outlined"
          autocomplete="off"
          id="reportName"
          label="Report Name"
          name="reportName"
          value={formik.values.reportName}
          onChange={(e, value)=>{
            formik.setFieldValue("reportName", e.target.value)
            setReportValue(e.target.value)
            console.log(e)
          }}
          error={Boolean(formik.touched.reportName && formik.errors.reportName)}
          helperText={formik.touched.reportName && formik.errors.reportName}
        />
      </Grid>
      {formik.errors.submit && (
        <Grid
          item
          xs={12}
        >
          <FormHelperText error>
            {formik.errors.submit}
          </FormHelperText>
        </Grid>
      )}
      </Grid>
  )
}

export default ReportDetail


export const ClientDetail = (props) => {
  const { formik, setClients } = props
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const classes = profileSettingStyles()
    const {clients} = useSelector(({client})=> client)
    const [selectedValue, setSelectedValue]= useState(null)
    useEffect(()=>{
        dispatch(fetchClients())
      },[])


  const handleSelect =(event, value)=>{
    setSelectedValue(value._id)
  }
  return (
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
      <Autocomplete
          disablePortal
          id="combo-box-demo"
          options = {clients}
          name="client"
          className={classes.textField1}
          getOptionLabel={ (client: Object | string) => client['clientName'] || client }
          getOptionSelected={(option, value) => option._id === value}
          value = {formik.values.client?.clientName}
          onChange={(e, val) => {
            formik.setFieldValue("client", val)
            formik.setFieldValue("property", "")
            setClients(val)
         }}
          renderInput={(params) => <CssTextField {...params}  name="client" label="Client"/>}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <Button style={{color:"rgb(115 74 153)"}} onClick={()=> navigate("/addClient", {state:{data:"/addReport"}})}>
          Add new client
        </Button>
      </Grid>
      {formik.errors.submit && (
        <Grid
          item
          xs={12}
        >
          <FormHelperText error>
            {formik.errors.submit}
          </FormHelperText>
        </Grid>
      )}
      </Grid>
  )
}

export const PropertyDetail = (props) => {
   const { formik, setProperties } = props

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const classes = profileSettingStyles()
    const {clientProperty} = useSelector(({property})=> property)

    useEffect(()=>{
        formik.values.client && dispatch(getclientProperty(formik.values.client?._id))
      },[formik.values.client])


  return (
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
      <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={clientProperty}
          name="property"
          disabled={formik.values.client ? false : true}
          className={classes.textField1}
          getOptionLabel={ (client: Object | string) => client['propertyName'] || client }
          getOptionSelected={(option, value) => option._id === value}
          value = {formik.values.property?.propertyName}
          onChange={(e, val) => {
            formik.setFieldValue("property", val)
            setProperties(val)
         }}
          renderInput={(params) => <CssTextField {...params}  name="property" label="Property" />}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        {formik?.values?.client ? <Button style={{color:"rgb(115 74 153)"}} onClick={()=> navigate("/addProperty", {state:{data:"/addReport", client: formik.values.client}})}>
          Add new Property
          </Button> : <Typography style={{color:"red"}}>Please select client</Typography>}
      </Grid>
      </Grid>
  )
}

export const Objective = (props) => {
  const { formik, setObjective } = props
    const classes = profileSettingStyles()

    useEffect(()=>{
    },[formik.values.client])

  return (
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          className={classes.textField1}
          required
          multiline
          rows={4}
          variant="outlined"
          autocomplete="off"
          label="Objective"
          name="objective"
          value={formik.values.objective}
          onChange={(e, value)=>{
            formik.setFieldValue("objective", e.target.value)
            setObjective(e.target.value)
            console.log(e)
          }}         
          error={formik.touched.objective && Boolean(formik.errors.objective)}
          helperText={formik.touched.objective && formik.errors.objective}
        />
      </Grid>
      </Grid>
  )
}

export const generateReport = (props) => {
  const { formik } = props
    const classes = profileSettingStyles()


  return (
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        {/* <CssTextField
          className={classes.textField1}
          required
          multiline
          rows={4}
          variant="outlined"
          autocomplete="off"
          label="Objective"
          name="objective"
          value={formik.values.objective}
          onChange={formik.handleChange}
          error={formik.touched.objective && Boolean(formik.errors.objective)}
          helperText={formik.touched.objective && formik.errors.objective}
        /> */}
      </Grid>
      </Grid>
  )
}